import type { CharacterCommission } from '@sorrem/shared';

/**
 * The commissions the Overview's Commissions section shows: every open one
 * (offered or accepted), or, when none is open, the most recently completed
 * one, so the player can see where they stand until the next is offered.
 * Every completed commission stays in the Journal.
 */
export function listShownCommissions(commissions: readonly CharacterCommission[]): CharacterCommission[] {
    const open = commissions.filter((commission) => commission.status !== 'completed');
    if (open.length > 0) {
        return open;
    }
    const lastCompleted = commissions
        .filter((commission) => commission.status === 'completed')
        .reduce<CharacterCommission | null>((latest, commission) => (latest === null
            || (commission.completedAt ?? '') > (latest.completedAt ?? '') ? commission : latest), null);
    return lastCompleted !== null ? [lastCompleted] : [];
}
